/* HairLock reveal engine — homepage only.
   Reveals elements with .hl-reveal as they scroll into view.
   Degrades gracefully: no IntersectionObserver or reduced-motion => show all. */
(function () {
  var els = document.querySelectorAll('.hl-reveal');
  if (!els.length) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) {
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

  els.forEach(function (el) { io.observe(el); });
})();
